import styled from 'styled-components';

export default styled.section`
  .inner {
    min-height: 50vh;

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transition: all 0.4s ease-in-out;
        transform: translateY(10px);
      }
    }

    .active& {
      opacity: 1;
      transform: none;
    }
  }

  .faqs {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .faq {
    margin: 0;
    padding: 0;

    &:first-child {
      a {
        padding-top: 0;
      }
    }

    &:last-child {
      a {
        padding-bottom: 0;
      }
    }

    a {
      color: ${props => props.theme.colors.grey1};
      text-decoration: none;
      padding: 0.75rem 0;
      display: block;
      line-height: 1em;
      transition: all 0.1s ease-in-out;

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        &:hover,
        &:focus,
        &:active {
          color: ${props => props.theme.colors.claytonBlue};
          text-decoration: underline;
        }
      }
    }
  }
`;
